import Vue from 'vue';
import {
  LIST,
  INIT,
} from './mutation-types';

export default {

  [LIST](state, response) {
    state.contracts = response.contracts;
    state.companySeq = response.companySeq;
    state.contractDownload = response.contractDownload;
  },
  [INIT](state, response) {
    state.contracts = [];
    state.companySeq = '';
    state.contractDownload = false;
  }

};
